import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal, PageShell, EASE } from "@/components/Reveal";

const ABSAETZE = [
  "Es gibt Themen, die uns immer wieder begegnen. Situationen, in denen wir ähnlich reagieren, obwohl wir es eigentlich anders möchten. Innere Unruhe, Unsicherheit oder das Gefühl, den Kontakt zu uns selbst verloren zu haben. Und manchmal wissen wir längst, dass sich etwas verändern soll – nur noch nicht, wie.",
  "In meiner 1:1-Begleitung schauen wir gemeinsam tiefer. Wir wenden uns dem zu, was sich in deinem Leben, deinen Gefühlen und deinem Körper zeigt, und folgen den Spuren zu dem, was darunter liegt.",
  "Dabei geht es nicht nur ums Verstehen. Dein Körper trägt Erfahrungen, Reaktionen und eine eigene tiefe Weisheit in sich. Wenn wir beginnen, ihm zuzuhören, können Zusammenhänge sichtbar und neue Wege spürbar werden.",
  "Ich begleite dich mit meiner Erfahrung, meiner Intuition und einem feinen Gespür für das, was sich im Moment zeigt. Dabei verbinde ich Gespräch mit Atem, achtsamer Körperarbeit, Berührung, Wingwave und Hypnose. Was wir davon nutzen, entwickelt sich aus dem jeweiligen Prozess und aus dem, was du gerade brauchst.",
  "So darf sich lösen, was dich einengt, und es entsteht wieder mehr Raum für dich. Du findest zurück in die Verbindung mit dir selbst, spürst deine innere Kraft und gewinnst Klarheit und Sicherheit. Du wirst wieder präsenter für dich und dein Leben – und für das, was dich lebendig fühlen lässt.",
];

export default function Begleitung() {
  return (
    <PageShell testid="begleitung-page">
      <PageHero
        title="Ganzheitliche 1:1-Begleitung"
        subtitle="Zurück in deine Kraft. Verbunden mit dir. Lebendig in deinem Leben."
        testid="begleitung-hero"
        compact
      />

      <section data-testid="begleitung-bild" className="px-6 pb-16 md:px-12 md:pb-24">
        <div className="mx-auto max-w-2xl">
          <Reveal>
            <div className="overflow-hidden rounded-[2.5rem]">
              <motion.img
                src="/images/begleitung-strand-herz.webp"
                alt="In den Sand gezeichnetes Herz am Strand unter strahlender Sonne"
                className="block h-auto w-full"
                initial={{ scale: 1.12 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.6, ease: EASE }}
              />
            </div>
          </Reveal>
        </div>
      </section>

      <section data-testid="begleitung-text" className="px-6 pb-16 md:px-12 md:pb-24">
        <div className="mx-auto max-w-3xl">
          {ABSAETZE.map((text, i) => (
            <Reveal key={i} delay={i * 0.05} className={i === 0 ? "" : "mt-8"}>
              <p className="text-base leading-loose text-anthrazit/85 md:text-lg">{text}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="px-6 pb-24 md:px-12 md:pb-36">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <Link
              to="/kontakt"
              data-testid="begleitung-kontakt-link"
              className="group inline-flex items-center gap-4 text-sm uppercase tracking-[0.3em] text-rot"
            >
              <span className="border-b border-rot/40 pb-1 transition-colors duration-500 group-hover:border-rot">
                Kontakt
              </span>
              <ArrowUpRight
                size={18}
                strokeWidth={1.5}
                className="transition-transform duration-500 group-hover:rotate-45"
              />
            </Link>
          </Reveal>
        </div>
      </section>
    </PageShell>
  );
}
